import styled from "styled-components";
import theme from "../styles/theme";
import Status from "../types/enum/Status";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import { RightAlign } from "./UtilsComponents";
import { Icon } from "@mui/material";

type CourseDropModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction: () => void;
  discardFunction: () => void;
  title: string;
  description: string;
  cancelFunction?: () => void;
};
const Title = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const Flex = styled(FlexGrow)`
  padding: 18px;
  width: 350px;
  background: #dd742c14;
  border-radius: 4px;
  margin: 24px 0px;
`;
const Desc = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  padding: 16px 0;
  display: flex;
  align-items: center;
  text-align: center;
  margin: 0px 10px;
`;

const ConfirmChanges = ({
  isOpen,
  setOpen,
  confirmFunction,
  discardFunction,
  title,
  description,
}: CourseDropModalProps): JSX.Element => {
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: { maxWidth: "500px", padding: "0 16px 24px 16px" },
        }}
      >
        <FlexBox style={{ height: "64px", borderBottom: "1px solid #3C406C" }}>
          <FlexGrow>
            <Title>
              <Icon color="warning">warning_rounded</Icon>
              {title}
            </Title>
          </FlexGrow>
          <ClickableIcon
            name="close"
            // color="white"
            onClick={() => setOpen(false)}
          />
        </FlexBox>
        <FlexBox>
          <Flex>
            <Desc>{description}</Desc>
          </Flex>
        </FlexBox>
        <FlexBox justify="end">
          <FlexGrow style={{ flexGrow: "0" }}>
            <div
              className="reduce_opct_onhover"
              style={{
                display: "flex",
                alignItems: "center",
                width: "151px",
                height: "48px",
                color: "red",
                // textShadow: "0 2px 2px #ff000045",
                cursor: "pointer",
                // backgroundColor: '#c75151'
              }}
              onClick={() => {
                discardFunction();
              }}
            >
              Discard Changes
            </div>
          </FlexGrow>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              className="reduce_opct_onhover"
              style={{
                width: "151px",
                height: "48px",
                padding: "13px 12px",
                color: "white",
                background: theme.color.blueButton,
                boxShadow: "0 0 5px gray",
                border: "none",
              }}
              type="button"
              onClick={() => {
                confirmFunction();
              }}
            >
              Save Changes
            </Button>
          </FlexGrow>
        </FlexBox>
      </Modal>
    </>
  );
};

export default ConfirmChanges;
